import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import ClientPriceList from "@/components/ClientPriceList";
import { useEffect } from "react";

export default function ClientPriceListPage() {
  const { clientCode } = useParams();
  const [searchParams] = useSearchParams();
  const clientName = searchParams.get("name") || "";
  const navigate = useNavigate();
  const { user } = useAuth();

  // Update page title
  useEffect(() => {
    document.title = `Price List - ${clientCode} | EAC`;
    return () => {
      document.title = "EAC";
    };
  }, [clientCode]);

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Please login to continue</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Top Navigation Bar */}
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={() => navigate("/ledger")}
              className="gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Ledger
            </Button>
            <div className="h-6 w-px bg-slate-200" />
            <h1 className="text-lg font-semibold text-slate-800">
              DP CLIENTS Price List
            </h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto p-6">
        <div className="bg-white rounded-xl shadow-sm border p-6">
          <ClientPriceList
            clientCode={clientCode}
            clientName={clientName}
            onClose={() => navigate("/ledger")}
            isFullPage={true}
          />
        </div>
      </div>
    </div>
  );
}
